import { validTeacherRoles } from "features/user/consts";

export const ADD_COURSE_DROPDOWN_TEXT = "+ Add course";
export const NAVIGATE_TO_ADD_COURSE_VALUE = "-1";

export const ADD_COURSE_DROPDOWN_OPTION = {
  label: ADD_COURSE_DROPDOWN_TEXT,
  value: NAVIGATE_TO_ADD_COURSE_VALUE
};

export const ENABLE_EQ_SUGGEST_FORM = false;

export const SENIOR_TEACHER_ROLES = validTeacherRoles.filter(
  teacher => !["classroom_teacher", "non_teaching_staff"].includes(teacher)
);

export enum ExpiryType {
  premium = "Seneca Premium",
  misSync = "School Sync"
}

export const SCHOOL_MANAGEMENT_ANALYTICS_NAMESPACE = "s/schoolManagement";
